var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehaviour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.71,
    y: 8.53,
    width: 85.94,
    height: 85.94
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.25,28.73C80.35,26,77,24.19,70.68,23.21c-2.36-.37-4.64-.55-6.14-.64-.52-1.4-1.37-3.51-2.42-5.65-2.81-5.72-5.49-8.39-8.44-8.39s-5.62,2.67-8.44,8.39c-1,2.14-1.89,4.25-2.42,5.65-1.49.09-3.77.27-6.13.64-6.32,1-9.68,2.74-10.58,5.52s.8,6.16,5.41,10.54c1.7,1.61,3.43,3,4.61,3.94-.4,1.46-1,3.7-1.37,6.07-1.1,6.36-.5,10.13,1.88,11.86a5.81,5.81,0,0,0,4.45.86V92a2.52,2.52,0,0,0,4.3,1.78l8.29-8.29L62,93.73A2.52,2.52,0,0,0,66.27,92V62a8,8,0,0,0,1.26.1,5.23,5.23,0,0,0,3.19-1c2.38-1.73,3-5.5,1.89-11.86-.42-2.37-1-4.61-1.38-6.07a60.43,60.43,0,0,0,4.61-3.94C80.45,34.89,82.17,31.54,81.25,28.73Zm-20,57.14L55.46,80.1a2.52,2.52,0,0,0-3.56,0l-5.77,5.77V60.35q1.09-.51,2.31-1.17c2.08-1.13,4-2.37,5.24-3.21,1.25.84,3.16,2.08,5.25,3.21.8.44,1.57.83,2.3,1.17ZM72.05,35.92a60.39,60.39,0,0,1-5.18,4.28,2.52,2.52,0,0,0-.94,2.8,62.16,62.16,0,0,1,1.63,6.7c1,5.36.37,7,.19,7.35-.37.06-2.11.11-6.82-2.51a63.51,63.51,0,0,1-5.76-3.68,2.55,2.55,0,0,0-3,0,60.26,60.26,0,0,1-5.72,3.66c-4.73,2.64-6.48,2.59-6.85,2.53-.18-.34-.8-2,.18-7.35A62.33,62.33,0,0,1,41.43,43a2.53,2.53,0,0,0-.93-2.8,59.64,59.64,0,0,1-5.19-4.28c-3.49-3.25-4.34-5.09-4.4-5.63.24-.25,1.54-1.37,7-2.17a63.79,63.79,0,0,1,6.82-.59A2.51,2.51,0,0,0,47,25.81a61.44,61.44,0,0,1,2.57-6.29c2.09-4.36,3.6-5.72,4.1-5.94.5.22,2,1.58,4.1,5.94a58.87,58.87,0,0,1,2.57,6.29,2.52,2.52,0,0,0,2.34,1.72,61.37,61.37,0,0,1,6.76.58c4.86.71,6.64,1.76,7,2.18C76.39,30.82,75.55,32.66,72.05,35.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviour);
export default __webpack_public_path__ + "static/media/behaviour.40e045daf9a807fa6f2a4a6e6d968b8a.svg";
export { ForwardRef as ReactComponent };